import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';
import { useSidebarCollapseOptional } from '../../context/SidebarCollapseContext';
import SidebarFooterPortal from '../layout/SidebarFooterPortal';

/**
 * RFID-style sidebar brand strip (black rail) + footer collapse portal.
 */
const AppLogo = () => {
  const drawer = useSidebarCollapseOptional();
  const collapsed = drawer?.sidebarCollapsed ?? true;

  return (
    <>
      <Link
        to="/dashboard"
        className={cn(
          'leap-sidebar-brand',
          collapsed ? 'leap-sidebar-brand--collapsed' : 'leap-sidebar-brand--expanded'
        )}
        aria-label="MyLEAP home"
      >
        <span className="leap-sidebar-brand__mark" aria-hidden="true">
          <img
            src="/assets/images/leap-favicon-white.png"
            alt=""
            width={28}
            height={28}
            draggable={false}
          />
        </span>
        {!collapsed ? (
          <span className="leap-sidebar-brand__meta">
            <span className="leap-sidebar-brand__title">MyLEAP</span>
            <span className="leap-sidebar-brand__subtitle">Portal</span>
          </span>
        ) : null}
      </Link>
      <SidebarFooterPortal />
    </>
  );
};

export default AppLogo;

AppLogo.propTypes = {
  hasColor: PropTypes.bool,
};
